import React from "react"
import { RiCloseLine } from "react-icons/ri"
import * as style from "./Quickfilter.module.scss"

const Quickfilter = ({ filterValue, onValueChange, microcopy }) => {
  const handleClearInput = () => {
    onValueChange("")
  }

  return (
    <div className={style.container}>
      <input
        className={style.input}
        type="text"
        value={filterValue}
        onChange={(event) => onValueChange(event.target.value)}
        placeholder={microcopy.text("reference.sidebar.filter.placeholder")}
      />
      {filterValue && (
        <RiCloseLine className={style.clearIcon} onClick={handleClearInput} />
      )}
    </div>
  )
}

export default Quickfilter
